import {decompose} from './decompose'

export const getNodeAttrs = (node, type, stage) => {
  const transform = stage.getAbsoluteTransform().copy()
  transform.invert()
  const matrix = transform
    .multiply(node.getAbsoluteTransform())
    .getMatrix()
  const attrs = decompose(matrix)
  switch (type) {
    case 'rect':
    case 'circle':
    case 'line':
    case 'arrow':
    case 'doubleArrow':
    case 'dashedArrow':
    case 'doubleDashedArrow':
    case 'eye':
    case 'text':
    case 'customText':
    case 'group':
      return {
        ...node.getAttrs(),
        ...attrs
      }
    case 'customArrow':
    case 'customDoubleArrow':
      const {width, height} = node.getClientRect({
        skipTransform: true,
        skipShadow: true,
        skipStroke: true,
        relativeTo: stage
      })
      return {
        ...node.getAttrs(),
        ...attrs,
        width: width * attrs.scaleX,
        height: (height * attrs.scaleY) / 4
      }
  }
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/getNodeAttrs.js